import { TabIds } from "features/CenterContent/RoleContent/useTabsForRole";
import { useEffect } from "react";
import { generatePath, useNavigate } from "react-router-dom";
import {
  createListCollection,
  Select,
  SelectItem,
} from "shared/components/Spor";
import { StyleTarget } from "shared/components/StyleTarget";
import { useUserInfo } from "shared/hooks/useUserInfo";
import { isValidUserRole, ROLE_TEXTS } from "shared/types/roles";
import * as ROUTES from "shared/utils/routes";
import { useDropsRole } from "stores/useDropsRole";
import styled, { css, useTheme } from "styled-components";
// This adjusts the position of the role label in Select. Tried to
// do this globally, but weren't able to modify label -> transform.
const RoleContainer = styled.div<{ longestLabel: number }>`
  button > :first-child > :first-child {
    transform: scale(0.8) translateY(-2px) translateX(-5px);
  }
  min-width: ${({ longestLabel }) => `${longestLabel + 5}ch`};
`;

const SelectRole = () => {
  const navigate = useNavigate();
  const { role, setRole } = useDropsRole();

  const theme = useTheme();
  const { roles: assignedRoles } = useUserInfo();
  const roleTexts = ROLE_TEXTS.filter((it) =>
    assignedRoles?.includes(it.value),
  );

  const longestLabel = roleTexts.reduce(
    (prev, curr) => (curr.text.length > prev ? curr.text.length : prev),
    0,
  );

  const rolesItems = createListCollection({
    items: roleTexts.map(({ text, value }) => ({ label: text, value })),
  });

  // Update defaultRole using assignedRoles
  useEffect(() => {
    if (rolesItems.items.length === 0) return;
    if (rolesItems.items.find((it) => it.value === role)) return;
    setRole(rolesItems.items[0].value);
  }, [role, rolesItems]);

  return (
    <RoleContainer longestLabel={longestLabel}>
      <StyleTarget
        // Fine-tunes select-role height to fit the header
        $style={css`
          height: 36px;
          background-color: ${theme.colorBackgroundMain};

          * {
            background-color: inherit;
          }
        `}
        $target="button"
      >
        <Select
          name="role"
          collection={rolesItems}
          value={[role]}
          onValueChange={({ value: _value }) => {
            const [value] = _value;
            if (typeof value !== "string") return;
            if (!isValidUserRole(value)) return;
            setRole(value);
            navigate(
              generatePath(ROUTES.LANDING, {
                roleIdParam: value,
                tabIdParam: TabIds.START,
              }),
            );
          }}
          minW="300px"
        >
          {rolesItems.items.map((item) => (
            <SelectItem key={item.value} item={item}>
              {item.label}
            </SelectItem>
          ))}
        </Select>
      </StyleTarget>
    </RoleContainer>
  );
};

export default SelectRole;
